<template>
    <ThePage class="container">
        <template v-slot:title>{{ company.name || 'Компания без названия' }}</template>

        <div class="card mb-4">
            <div class="card-body">
                <div class="lead mb-4">
                    Статус: {{ company.state | companyStateText }} от {{ company.state_changed_at | date | nodata }}. Баланс: {{ company.balance }} {{ company.balance_currency | currencySymbol }}.
                </div>

                <button type="button" class="btn btn-lg-192 btn-primary mb-4" @click.once="signIn">Войти в ЛК</button>

                <div style="max-width: 400px" class="pb-4">
                    <div class="row">
                        <div class="col">Пользователь</div>
                        <div class="col">{{ company.user_first_name | nodata }} {{ company.user_last_name | nodata }}</div>
                    </div>
                    <div class="row">
                        <div class="col">Email</div>
                        <div class="col">{{ company.user_email | nodata }}</div>
                    </div>
                    <div class="row">
                        <div class="col">Телефон</div>
                        <div class="col">{{ company.user_phone | nodata }}</div>
                    </div>
                </div>

                <div class="pb-4">
                    <h5 class="lead">Реквизиты</h5>
                    <p>ИНН: {{ requisites.inn | nodata }}</p>

                    <div v-if="requisites.inn && company.is_verified === false" class="btn-group mb-4">
                        <button type="button" class="btn btn-primary" @click.stop="confirmRequisites(true)">Подтвердить</button>
                        <button type="button" class="btn btn-danger" @click.stop="confirmRequisites(false)">Отказать</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-between mb-3">
            <div class="font-weight-bold">Последние транзакции</div>
            <button type="button" class="btn btn-primary" @click="$refs.correction.show()">Корректировка</button>
        </div>

        <div class="card">
            <div class="card-body">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Сумма</th>
                            <th>Дата</th>
                            <th class="w-75 d-none d-md-table-cell">Комментарий</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="tx in transactions" :key="tx.id">
                            <td class="text-nowrap">
                                <strong :class="[ tx.type === 1 ? 'text-success' : 'text-danger' ]">{{ tx.amount | money }} {{ currency | currencySymbol }}</strong>
                            </td>
                            <td class="text-nowrap">{{ tx.created_at | date }}</td>
                            <td class="d-none d-md-table-cell">
                                <div style="white-space: pre-wrap">{{ tx.comment || '–' }}</div>

                                <div v-if="tx.user && tx.subtype === 2" class="text-primary">
                                    Скорректировал: <span>{{ tx.user.name }}</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                    <tfoot v-if="transactions.length === 0" class="no-one">
                        <tr>
                            <td colspan="4">История начислений и списаний пуста.</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>

        <page-correction-add ref="correction" :currency="currency" :pending="pending" @submit="createCorrection" />
    </ThePage>
</template>

<script>
import store from '@/store'
import adminStoreModule from '@/store/modules/admin'

import ThePage from '@/components/ThePage'
import PageCorrectionAdd from '@/components/admin/pages/PageCorrectionAdd'

import { reset as resetSelectPlanogram } from '@/components/SelectPlanogram'
import { reset as resetSelectComponent } from '@/components/SelectComponent'
import { reset as resetSelectProduct } from '@/components/SelectProduct'

import { toastSuccess, toastError } from '@/dialogs'

if (!store.state['admin']) {
    store.registerModule('admin', adminStoreModule)
}

export default {
    components: {
        ThePage,
        PageCorrectionAdd
    },

    data() {
        return {
            pending: false
        }
    },

    computed: {
        company() {
            return this.$store.state.admin.company.data
        },

        currency() {
            return this.company.balance_currency
        },

        requisites() {
            return this.company.requisites
        },

        transactions() {
            return this.$store.state.admin.company.transactions
        }
    },

    methods: {
        async signIn() {
            if (!this.company.id) {
                return
            }

            let done = await store.dispatch('admin/signIn', this.company.id)

            if (done) {
                await store.dispatch('company/profile/fetch')

                resetSelectPlanogram()
                resetSelectComponent()
                resetSelectProduct()

                this.$router.push({ name: 'home' })
            }
        },

        async confirmRequisites(value) {
            if (!this.company.id) {
                return
            }

            await store.dispatch('admin/company/confirmRequisites', {
                id: this.company.id,
                isVerified: value
            })
        },

        async createCorrection(attributes) {
            this.pending = true
            const done = await store.dispatch('admin/company/createTransaction', { id: this.company.id, attributes })
            this.pending = false

            done
                ? toastSuccess('Корректировка создана!')
                : toastError('Не удалось создать корректировку.')

            this.$refs.correction.close()
        }
    },

    async beforeRouteEnter(to, from, next) {
        await Promise.all([
            store.dispatch('admin/company/fetch', to.params.id),
            store.dispatch('admin/company/fetchTransactions', to.params.id)
        ])

        next()
    },

    async beforeRouteUpdate(to, from, next) {
        if (to.params.id !== from.params.id) {
            await store.dispatch('admin/company/fetch', to.params.id)
        }

        next()
    }
}
</script>
